export default "__VITE_ASSET__e53b88ca__"